export const Spinner = () => {
  return (
    <div className="flex justify-center mt-4">
      <div className="inline-flex h-1 rounded-full w-44 bg-primary" />
    </div>
  )
}
